import Vue from 'vue';
import request from '@/api/request';
import '@/assets/js/qrcode.js'; // 引用于qrcodejs2插件,由于没有图片路径回调 在插件基础上增加回调机制 用于绘制标签二维码

/* 公共数据处理 */
import '@/assets/js/common.js'; //引入全局通用属性和方法

import '@/assets/js/class.js'

request.defaults.baseURL = Vue.prototype.url;

/* 通用方法 */
import plugins from '@/assets/js/plugins'
Vue.use(plugins)

/* 复制插件 */
import Clipboard from 'vue-clipboard2';
Vue.use(Clipboard)

/* 浏览器打印 */
import Prints from '@/pulgs/print.js';
Vue.use(Prints)


/* 富文本编辑器 */
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/font/iconfont.css'; // 全局样式
import '@/assets/css/index.css'
Vue.use(VueQuillEditor)

/* 图片查看 large预览图地址 preview预览组 */
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  fullscreenEl: false,
}
Vue.use(preview, options)

/* 全局自定义指令 */
import * as directives from '@/assets/js/directives.js'
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

/* 数字滚动 */
// <count-to :start-val="0" :end-val="10000" :duration="3000" :decimals="2" />
import countTo from 'vue-count-to'
Vue.component('countTo', countTo)

// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)
/* 虚拟表格 */
import {
  UTable,
  UTableColumn
} from 'umy-ui';
Vue.use(UTable)
Vue.use(UTableColumn)

/* 地图插件 */
import '@/map.js';



// WEBPACK FOOTER //
// ./src/utils/index.js